import React from "react";
import useSWR from "swr";
import { api, formatDKK } from "@/lib/api";
import { Users, Coins, CheckCircle2, TrendingUp } from "lucide-react";

const fetcher = (url) => api.get(url).then((r) => r.data);

export default function StatsTab() {
  const { data, error } = useSWR("/admin/stats", fetcher);
  if (error) return <p className="text-red-600">Ошибка загрузки статистики</p>;
  if (!data) return <p className="text-stone-400">Загрузка…</p>;

  const cards = [
    { icon: Users, label: "Всего заявок", value: data.total_leads, testId: "stat-total-leads" },
    { icon: Coins, label: "Заказы в работе (с НДС)", value: formatDKK(data.pipeline_value_incl_vat), testId: "stat-pipeline" },
    { icon: CheckCircle2, label: "Выполнено заказов", value: data.completed_count, testId: "stat-completed" },
    { icon: TrendingUp, label: "Конверсия", value: `${data.conversion_rate}%`, testId: "stat-conversion" },
  ];

  return (
    <div data-testid="admin-stats-tab">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-stone-200 rounded-2xl p-5" data-testid={c.testId}>
            <c.icon className="w-6 h-6 text-[#1E3A2F]" />
            <div className="mt-3 text-2xl font-display font-bold text-stone-900">{c.value}</div>
            <div className="text-sm text-stone-500">{c.label}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <div className="bg-white border border-stone-200 rounded-2xl p-5">
          <h3 className="font-semibold text-stone-900 mb-3">По статусам</h3>
          <ul className="space-y-2">
            {Object.entries(data.by_status).map(([k, v]) => (
              <li key={k} className="flex justify-between text-sm"><span className="text-stone-600">{k}</span><span className="font-mono font-semibold">{v}</span></li>
            ))}
          </ul>
        </div>
        <div className="bg-white border border-stone-200 rounded-2xl p-5">
          <h3 className="font-semibold text-stone-900 mb-3">По услугам · Выручка и прибыль по выполненным (только админ)</h3>
          <ul className="space-y-2">
            {Object.entries(data.by_service).map(([k, v]) => (
              <li key={k} className="flex justify-between text-sm"><span className="text-stone-600 uppercase">{k}</span><span className="font-mono font-semibold">{v}</span></li>
            ))}
          </ul>
          <div className="mt-4 pt-4 border-t border-stone-100 space-y-2 text-sm">
            <div className="flex justify-between"><span className="text-stone-600">Выручка без НДС</span><span className="font-mono font-semibold">{formatDKK(data.completed_revenue_excl_vat)}</span></div>
            <div className="flex justify-between"><span className="text-stone-600">Валовая прибыль</span><span className="font-mono font-semibold text-emerald-700">{formatDKK(data.completed_gross_profit)}</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
